import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=2a2e8c5c&scoped=true&"
import script from "./newsList.vue?vue&type=script&lang=js&"
export * from "./newsList.vue?vue&type=script&lang=js&"
import style0 from "./newsList.vue?vue&type=style&index=0&id=2a2e8c5c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2e8c5c",
  null
  
)

component.options.__file = "newsList.vue"
export default component.exports